import { PermitApplicationClient } from '@src/permits/services/PermitApplicationClient';
import { useMutation } from '@tanstack/react-query';

interface Props {
  onSuccess: (pdfBlob: Blob) => void;
  onError: () => void;
}

export const useMergePdfs = ({ onSuccess, onError }: Props) => {
  const { mutate: mergePdfs, isPending: isMergingPdfs } = useMutation({
    mutationFn: async (permitApplicationIds: string[]) => {
      return await PermitApplicationClient.mergePermits({
        permitApplicationIds,
      });
    },
    onSuccess,
    onError,
  });

  return { mergePdfs, isMergingPdfs };
};
